module.exports = __webpack_public_path__ + "img/hezuoqiye1bg.fc66d4dd.png";